module.exports = __webpack_public_path__ + "img/pc_footer_img.d8682cd.webp";